import { store } from 'react-easy-state'

const _store = store({
  userId: '',
  userName: '',

  setUserInfo(userId, displayName) {
    _store.userId = userId
    _store.userName = displayName
  }
})

export default _store
